module.exports = __webpack_public_path__ + "img/close.60f46cf7.svg";